import { render, staticRenderFns } from "./StopEffectQueryDataTable.vue?vue&type=template&id=0a96733a&scoped=true"
import script from "./StopEffectQueryDataTable.vue?vue&type=script&lang=js"
export * from "./StopEffectQueryDataTable.vue?vue&type=script&lang=js"
import style0 from "./StopEffectQueryDataTable.vue?vue&type=style&index=0&id=0a96733a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a96733a",
  null
  
)

export default component.exports